import { render, staticRenderFns } from "./studentKPIPage.vue?vue&type=template&id=6461a1d5&scoped=true"
import script from "./studentKPIPage.vue?vue&type=script&lang=js"
export * from "./studentKPIPage.vue?vue&type=script&lang=js"
import style0 from "./studentKPIPage.vue?vue&type=style&index=0&id=6461a1d5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6461a1d5",
  null
  
)

export default component.exports